// These must be the first lines in src/index.js
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import registerServiceWorker from './registerServiceWorker'
import {HashRouter, Route, Switch} from 'react-router-dom'
import 'antd/dist/antd.css';
import {ConfigProvider} from 'antd';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
// import Sign from "./router/sign/sign";
import Pages from "./router/pages/pages";
import './libs/i18n/i18n';
import utils from "./libs/utils";
// 引入Provider链接组件和store
import store from "./store/index";
import {Provider} from 'react-redux';

/*international language*/
let intl_lang = 'zh';

/*
let browser_lang = navigator.language;
browser_lang = browser_lang.substr(0, 2);
if (browser_lang) {
    if ('zh' === browser_lang) {
        intl_lang = 'zh';
    } else if ('en' === browser_lang) {
        intl_lang = 'en';
    }
} else {
    intl_lang = 'en';
}
*/

utils.localStorageSet('current_language', intl_lang);
moment.locale('zh-cn');

ReactDOM.render(
    <HashRouter>
        <ConfigProvider locale={zh_CN}>
            <Provider store={store}>
                <Switch>
                    {/*<Route path='/sign' component={Sign}/>*/}
                    <Route path='' component={Pages}/>
                </Switch>
            </Provider>
        </ConfigProvider>
    </HashRouter>
    , document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js